import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ClientErrorController::frontend
* @see app/Http/Controllers/ClientErrorController.php:13
* @route 'https://org.proexpert.app/__proexpert/client-errors'
*/
export const frontend = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: frontend.url(options),
    method: 'post',
})

frontend.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/__proexpert/client-errors',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClientErrorController::frontend
* @see app/Http/Controllers/ClientErrorController.php:13
* @route 'https://org.proexpert.app/__proexpert/client-errors'
*/
frontend.url = (options?: RouteQueryOptions) => {
    return frontend.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClientErrorController::frontend
* @see app/Http/Controllers/ClientErrorController.php:13
* @route 'https://org.proexpert.app/__proexpert/client-errors'
*/
frontend.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: frontend.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClientErrorController::frontend
* @see app/Http/Controllers/ClientErrorController.php:13
* @route 'https://org.proexpert.app/__proexpert/client-errors'
*/
const frontendForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: frontend.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClientErrorController::frontend
* @see app/Http/Controllers/ClientErrorController.php:13
* @route 'https://org.proexpert.app/__proexpert/client-errors'
*/
frontendForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: frontend.url(options),
    method: 'post',
})

frontend.form = frontendForm

const clientErrors = {
    frontend: Object.assign(frontend, frontend),
}

export default clientErrors